module.exports = __webpack_public_path__ + "step1_F2M_kanai_bridal.4e62595d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_F2M_kanai_bridal.jpg
// module id = La3S
// module chunks = 0